<template>
  <div class="team-user-detail">
    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="main-content">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>正在加载成员信息...</p>
      </div>

      <!-- 错误状态 -->
      <div v-else-if="error" class="error-container">
        <div class="error-icon">⚠️</div>
        <p>未找到成员信息，请返回团队页面重试。</p>
      </div>

      <!-- 正常内容 -->
      <template v-else>
        <!-- 个人信息头部 -->
        <section class="profile-header">
          <div class="container">
            <div class="profile-card">
              <div class="profile-avatar">
                <img :src="memberData.image" :alt="memberData.name" class="avatar-image">
              </div>
              <div class="profile-info">
                <h1 class="member-name">{{ memberData.name }}</h1>
                <div class="member-positions">
                  <span class="position-primary">{{ memberData.title }}</span>
                  <span class="position-secondary" v-if="memberData.subtitle">{{ memberData.subtitle }}</span>
                </div>
                <div class="member-languages" v-if="memberData.workLang">
                  <span class="label">{{ $t('wklang') }}</span>
                  <span class="languages">{{ memberData.workLang }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- 详细信息内容 -->
        <section class="profile-content">
          <div class="container">
            <div class="content-grid">
              <!-- 左侧内容 -->
              <div class="content-left">
                <!-- 专业经验 -->
                <div class="info-section" v-show="memberData.workExp&&memberData.workExp.length>0">
                  <h2 class="section-title">
                    <i class="icon-briefcase"></i>
                    {{ $t('team.textt02') }}
                  </h2>
                  <div class="section-content">
                    <div v-for="(wkdetail, index) in memberData.workExp" :key="index">
                      <p>{{ wkdetail }}</p>
                    </div>

                  </div>
                </div>
                <!-- 业务领域 -->
                <div class="info-section" v-if="memberData.bisArea">
                  <h2 class="section-title">
                    <i class="icon-briefcase"></i>
                    {{ $t('team.textt04') }}
                  </h2>
                  <div class="section-content">
                    <p>{{ memberData.bisArea }}</p>
                  </div>
                </div>

              </div>

              <!-- 右侧内容 -->
              <div class="content-right" v-show="memberData.education&&memberData.education.length>0&&hezhixinNotShowJiaoyu">
                <!-- 教育背景 -->
                <div class="info-section">
                  <h2 class="section-title">
                    <i class="icon-education"></i>
                    {{ $t('team.textt03') }}
                  </h2>
                  <div class="section-content">
                    <div class="education-list">
                      <div v-for="(edu, index) in memberData.education" :key="index" class="education-item">
                        <div class="edu-icon">🎓</div>
                        <div class="edu-content">
                          <p>{{ edu }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </template>
    </main>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'TeamUserDetail',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      memberData: {},
      loading: true,
      error: false,
      hezhixinNotShowJiaoyu:true,
    }
  },
  created() {
    console.log('详情页路由：', this.$route)

    // 直接初始化成员数据，不再尝试修改路由
    this.initMemberData()
  },
  methods: {
    initMemberData() {
      console.log('初始化成员数据，当前路由：', this.$route)

      // 优先从 query 接收数据
      const queryData = this.$route.query && this.$route.query.data
      if (queryData) {
        try {
          this.memberData = JSON.parse(decodeURIComponent(queryData))
          console.log('从 query 成功解析成员数据：', this.memberData)
          this.loading = false
          return
        } catch (e) {
          console.warn('解析 query 数据失败：', e)
        }
      }

      // 兼容 params 方式
      if (this.$route.params && this.$route.params.memberData) {
        this.memberData = this.$route.params.memberData
        console.log('从 params 获取成员数据：', this.memberData)
        this.loading = false
        if(this.memberData.name=='何志欣'||this.memberData.name=='Dipl.-Ing Zhixin HE'||this.memberData.name=='Dipl.-Ing. Zhixin HE'){
          this.hezhixinNotShowJiaoyu=false
          console.log('从 params 获取成员数据 hezhixinNotShowJiaoyu：', this.hezhixinNotShowJiaoyu)
        }
        return
      }

      // 路由守卫现在会处理数据不存在的情况，这里只设置错误状态
      console.error('在 teamUserDetail 中未找到成员数据。')
      this.error = true
      this.loading = false
    },

    goBack() {
      this.$router.go(-1) // 使用浏览器历史记录返回，更自然
    }
  }
}
</script>

<style scoped>
.team-user-detail {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
  background: #f8f9fa;
}

.main-content {
  min-height: 80vh;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 2rem 0;
}

/* 个人信息头部 */
.profile-header {
  background: linear-gradient(135deg, #FF631E 0%, #FF7A3D 100%);
  color: white;
  padding: 3rem 0;
}

.profile-card {
  display: flex;
  align-items: center;
  gap: 2rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 2rem;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.profile-avatar {
  flex-shrink: 0;
}

.avatar-image {
  width: 130px;
  height: auto;
  border-radius: 20px;
  object-fit: cover;
  border: 4px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.profile-info {
  flex: 1;
}

.member-name {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.member-positions {
  margin-bottom: 1rem;
}

.position-primary {
  font-size: 1.3rem;
  font-weight: 600;
  margin-right: 1rem;
}

.position-secondary {
  font-size: 1.1rem;
  opacity: 0.9;
}

.member-languages {
  font-size: 1rem;
  opacity: 0.9;
}

.label {
  font-weight: 600;
  margin-right: 0.5rem;
}

/* 详细内容区域 */
.profile-content {
  padding: 3rem 0;
}

.content-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3rem;
}

.info-section {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.info-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(255, 99, 30, 0.15);
}

.section-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #FF631E;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-title i {
  font-size: 1.2rem;
  color: #FF631E;
}

/* 图标样式 */
.icon-user::before {
  content: '👤';
}

.icon-briefcase::before {
  content: '💼';
}

.icon-experience::before {
  content: '🏆';
}

.icon-education::before {
  content: '🎓';
}

.icon-contact::before {
  content: '📞';
}

.section-content {
  color: #555;
  line-height: 1.8;
}

/* 业务领域标签 */
.business-areas {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
}

.area-tag {
  background: linear-gradient(135deg, #FF631E, #FF7A3D);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(255, 99, 30, 0.3);
}

/* 经验时间线 */
.experience-timeline {
  position: relative;
  padding-left: 2rem;
}

.experience-timeline::before {
  content: '';
  position: absolute;
  left: 0.5rem;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #FF631E, #FF7A3D);
}

.timeline-item {
  position: relative;
  margin-bottom: 2rem;
}

.timeline-dot {
  position: absolute;
  left: -1.5rem;
  top: 0.5rem;
  width: 12px;
  height: 12px;
  background: #FF631E;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 0 0 2px #FF631E;
}

.timeline-content {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 12px;
  border-left: 4px solid #FF631E;
}

.exp-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.exp-period {
  font-size: 0.9rem;
  color: #FF631E;
  font-weight: 500;
  margin-bottom: 0.8rem;
}

.exp-description {
  color: #666;
  line-height: 1.6;
}

/* 教育背景 */
.education-list {
  space-y: 1rem;
}

.education-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 1rem;
  border-left: 4px solid #FF631E;
}

.edu-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.edu-content p {
  margin: 0;
  color: #555;
  line-height: 1.6;
}

/* 联系方式 */
.contact-info {
  space-y: 1rem;
}

.contact-item {
  display: flex;
  align-items: center;
  padding: 0.8rem 0;
  border-bottom: 1px solid #eee;
}

.contact-item:last-child {
  border-bottom: none;
}

.contact-label {
  font-weight: 600;
  color: #333;
  min-width: 80px;
}

.contact-value {
  color: #555;
}

.contact-placeholder {
  text-align: center;
  color: #999;
  font-style: italic;
  padding: 2rem 0;
}

/* 操作按钮 */
.action-section {
  margin-top: 2rem;
}

.back-button {
  width: 100%;
  background: linear-gradient(135deg, #FF631E, #FF7A3D);
  border: none;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(255, 99, 30, 0.3);
  transition: all 0.3s ease;
}

.back-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255, 99, 30, 0.4);
}

/* 加载和错误状态样式 */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #FF631E;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.loading-container p,
.error-container p {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
}

@media (max-width: 992px) {
  .content-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .profile-card {
    flex-direction: column;
    text-align: center;
  }

  .member-name {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .profile-header {
    padding: 2rem 0;
  }

  .profile-card {
    padding: 1.5rem;
  }

  .avatar-image {
    width: 120px;
    height: 120px;
  }

  .member-name {
    font-size: 1.8rem;
  }

  .info-section {
    padding: 1.5rem;
  }

  .experience-timeline {
    padding-left: 1.5rem;
  }

  .timeline-dot {
    left: -1.25rem;
  }
}

@media (max-width: 576px) {
  .business-areas {
    flex-direction: column;
  }

  .area-tag {
    text-align: center;
  }

  .education-item,
  .timeline-content {
    padding: 1rem;
  }
}
</style>